module.exports = __webpack_public_path__ + "static/media/slide5-mobile.2e172dd2.jpg";